import { useEffect, useState } from "react";

/** Width of `element`, kept current by a ResizeObserver; 0 until first measured. */
export function useElementWidth(element: HTMLElement | null): number {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!element) return;

    const observer = new ResizeObserver(([entry]) =>
      setWidth(entry?.contentRect.width ?? 0),
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [element]);

  return width;
}
